module.exports = __webpack_public_path__ + "static/media/bf14.e0e458da.png";